export const rtBloggerServiceImplFactory = ({
  rtBloggerRepository,
}: {
  rtBloggerRepository: IRTBloggerRepository;
}) => {
  const postParseRTARService: IPostParseRTARService = async ({
    file,
    clinic_id,
  }) => {
    try {
      const response = await rtBloggerRepository.postParseRTARAPI({
        file,
        clinic_id,
      });

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getBillingSettingsService: IGetBillingSettingsService = async (
    payload
  ) => {
    try {
      const response = await rtBloggerRepository.getBillingSettingsAPI(payload);

      return {
        success: true,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateBillingSettingsService: IUpdateBillingSettingsService = async (
    payload
  ) => {
    try {
      const response = await rtBloggerRepository.updateBillingSettingsAPI(
        payload
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getServicesService: IGetServicesService = async (payload) => {
    try {
      const response = await rtBloggerRepository.getServicesAPI(payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateServicesService: IUpdateServicesService = async (payload) => {
    try {
      const response = await rtBloggerRepository.updateServicesAPI(payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getAuditService: IGetAuditService = async (payload) => {
    try {
      const response = await rtBloggerRepository.getAuditAPI(payload);

      return {
        success: true,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateAuditService: IUpdateAuditService = async (payload) => {
    try {
      const response = await rtBloggerRepository.updateAuditAPI(payload);

      return {
        success: true,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const postRTARBillingService: IPostRTARBillingService = async (payload) => {
    try {
      const response = await rtBloggerRepository.postRTARBillingAPI(payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getCPTTypesService: IGetCPTTypesService = async () => {
    try {
      const response = await rtBloggerRepository.getCPTTypesAPI();

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getEnrolledPatientsService: IGetEnrolledPatientsService = async (
    payload
  ) => {
    try {
      const response = await rtBloggerRepository.getEnrolledPatientsAPI(
        payload
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const putBillingServiceStatusService: IPutBillingServiceStatusService =
    async (payload) => {
      try {
        const response = await rtBloggerRepository.putBillingServiceStatusAPI(
          payload
        );

        return {
          success: true,
          data: response,
        };
      } catch (error) {
        return {
          success: false,
          error: { message: (error as unknown as Error).message },
        };
      }
    };
  const getOverviewPatientsService: IGetOverviewPatientsService = async (
    payload
  ) => {
    try {
      const response = await rtBloggerRepository.getOverviewPatientsAPI(
        payload
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getBillingCycleService: IGetBillingCycleService = async (payload) => {
    try {
      const response = await rtBloggerRepository.getBillingCycleAPI(payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getBillingCycleForPatientService: IGetBillingCycleForPatientService =
    async (payload) => {
      try {
        const response = await rtBloggerRepository.getBillingCycleForPatientAPI(
          payload
        );

        return {
          success: true,
          data: response,
        };
      } catch (error) {
        return {
          success: false,
          error: { message: (error as unknown as Error).message },
        };
      }
    };

  const deleteBillingCycleService: IDeleteBillingCycleService = async (
    payload
  ) => {
    try {
      const response = await rtBloggerRepository.deleteBillingCycleAPI(payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const putBillingCycleStatusForPatientService: IPutBillingCycleStatusForPatientService =
    async (payload) => {
      try {
        const response =
          await rtBloggerRepository.putBillingCycleStatusForPatientAPI(payload);

        return {
          success: true,
          data: response,
        };
      } catch (error) {
        return {
          success: false,
          error: { message: (error as unknown as Error).message },
        };
      }
    };

  const deleteBillingCycleForPatientService: IDeleteBillingCycleForPatientService =
    async (payload) => {
      try {
        const response =
          await rtBloggerRepository.deleteBillingCycleForPatientAPI(payload);

        return {
          success: true,
          data: response,
        };
      } catch (error) {
        return {
          success: false,
          error: { message: (error as unknown as Error).message },
        };
      }
    };

  const postBillingFilesService: IPostBillingFilesService = async (payload) => {
    try {
      const response = await rtBloggerRepository.postBillingFilesAPI(payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const putEnrollPatientService: IPutEnrollPatientService = async (payload) => {
    try {
      const response = await rtBloggerRepository.putEnrollPatientAPI(payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const postExtendEnrollPatientService: IPostExtendEnrollPatientService =
    async (payload) => {
      try {
        const response = await rtBloggerRepository.postExtendEnrollPatientAPI(
          payload
        );

        return {
          success: true,
          data: response,
        };
      } catch (error) {
        return {
          success: false,
          error: { message: (error as unknown as Error).message },
        };
      }
    };

  const getBillingReportsService: IGetBillingReportsService = async (
    payload
  ) => {
    try {
      const response = await rtBloggerRepository.getBillingReportsAPI(payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateBillingReportCollectedAmountService: IUpdateBillingReportCollectedAmountService =
    async (payload) => {
      try {
        const response =
          await rtBloggerRepository.updateBillingReportCollectedAmountAPI(
            payload
          );

        return {
          success: true,
          data: response,
        };
      } catch (error) {
        return {
          success: false,
          error: { message: (error as unknown as Error).message },
        };
      }
    };

  const getPreviouslyEnrolledPatientsService: IGetPreviouslyEnrolledPatientsService =
    async (payload) => {
      try {
        const response =
          await rtBloggerRepository.getPreviouslyEnrolledPatientsAPI(payload);

        return {
          success: true,
          data: response,
        };
      } catch (error) {
        return {
          success: false,
          error: { message: (error as unknown as Error).message },
        };
      }
    };

  const postFixErrorService: IPostFixErrorService = async (payload) => {
    try {
      const response = await rtBloggerRepository.postFixErrorAPI(payload);
      if ("detail" in response) {
        return {
          success: false,
          error: { message: response.detail },
        };
      }
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    postParseRTARService,
    getBillingSettingsService,
    updateBillingSettingsService,
    getServicesService,
    updateServicesService,
    getAuditService,
    updateAuditService,
    postRTARBillingService,
    getCPTTypesService,
    getEnrolledPatientsService,
    putBillingServiceStatusService,
    getBillingCycleService,
    getBillingCycleForPatientService,
    deleteBillingCycleService,
    putBillingCycleStatusForPatientService,
    deleteBillingCycleForPatientService,
    postBillingFilesService,
    putEnrollPatientService,
    postExtendEnrollPatientService,
    getOverviewPatientsService,
    getBillingReportsService,
    updateBillingReportCollectedAmountService,
    getPreviouslyEnrolledPatientsService,
    postFixErrorService,
  };
};
